export const createMatterTagHTML = (tag, media, dimensions) => {
  const container = document.createElement('div');
  container.id = 'tag-mesh';
  container.className = 'tag-mesh-wrapper';
  container.style.width = `${dimensions.width}px`;

  const header = document.createElement('div');
  header.className = 'tag-mesh-header';
  header.innerHTML = tag.title;

  const content = document.createElement('div');
  content.className = 'tag-mesh-content';

  const description = document.createElement('div');
  description.className = 'tag-mesh-description';
  description.innerHTML = tag.type === 'text' ? tag.text : tag.description;
  content.appendChild(description);

  let imageContainer = null;
  if (media) {
    imageContainer = document.createElement('img');
    imageContainer.className = 'tag-mesh-image';
    container.prepend(imageContainer);
  }

  container.appendChild(header);
  container.appendChild(content);
  document.body.appendChild(container);
  return { html: container, imageContainer };
};
